module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/frantmatter01"
    }
  }, [_c('i', [_vm._v("PROLOGUE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1. "), _c('i', [_vm._v("Our Hero")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2. "), _c('i', [_vm._v("Into the Hall")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. "), _c('i', [_vm._v("Thornmallow Gets to Class")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. "), _c('i', [_vm._v("First Spell")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. "), _c('i', [_vm._v("Rules")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. "), _c('i', [_vm._v("Meeting")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. "), _c('i', [_vm._v("Not a Wizard")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8. "), _c('i', [_vm._v("Classes")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9. "), _c('i', [_vm._v("Eavesdropping")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10. "), _c('i', [_vm._v("Telling Tales")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11. "), _c('i', [_vm._v("The Master Speaks")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12. "), _c('i', [_vm._v("The Story of the Beast")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13. "), _c('i', [_vm._v("Ideas")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14. "), _c('i', [_vm._v("Library Time")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15. "), _c('i', [_vm._v("Full Moon Night")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16. "), _c('i', [_vm._v("The Master and the Beast")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17. "), _c('i', [_vm._v("Magister Hickory’s Defense")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. "), _c('i', [_vm._v("The End of Wizard’s Hall")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. "), _c('i', [_vm._v("Thornmallow Really Tries")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. "), _c('i', [_vm._v("Unquilting the Beast")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. "), _c('i', [_vm._v("Saving Wizard’s Hall")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text2"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. "), _c('i', [_vm._v("The Enhancer")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("A Personal History by Jane Yolen")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53e656ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 63
// module chunks = 0